import Text, { TextVariant } from '@ui/Text/Text';
import cn from '@utils/cn';
import { TemplateColorPayload } from 'graphql/generated/types.autogenerated';

type Props = {
  colors?: TemplateColorPayload[] | null;
};
export default function ColorPreview({ colors }: Props) {
  if (!colors?.length) {
    return;
  }

  return (
    <div className="flex flex-col gap-2 sm:gap-2.5">
      <Text content="Colors" variant={TextVariant.TextBodyMD} />
      <div className="flex w-full gap-2">
        {colors
          .sort((a, b) => (a.area < b.area ? 1 : -1))
          .map((x, i) => (
            <div
              key={`${x.hexCode}-${i}`}
              className={cn('relative h-[24px] w-[50px] self-stretch rounded', 'border border-black/10')}
              style={{ backgroundColor: x.hexCode }}
            />
          ))
          .slice(0, 5)}
      </div>
    </div>
  );
}
